import styled from 'styled-components';

export const Container = styled.button`
  width: 4rem;
  height: 4rem;
  border-radius: 2rem;
  background-color: rgba(0, 0, 0, 0.2);
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 1rem 0 0;

  @media (max-width: 1024px) {
  }
`;
